// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"308":"1cc796c4","562":"852870f0","597":"31d6cfe0","856":"8c4f612e","996":"43768b9c"}[chunkId] + ".chunk.css";
};